import { API, Endpoints } from '@brg/api';
import { LMS_DESIGNER_SEARCH_GLOBAL_TYPES } from './constants';

export const fetchLmsDesignerAutoComplete = (key: string) =>
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Designer/AutoComplete')
    .get()
    .addQuery('key', key.trim())
    .addQuery('globalTypes', [...LMS_DESIGNER_SEARCH_GLOBAL_TYPES])
    .send();
import { API, Endpoints } from '@brg/api';
import { LMS_DESIGNER_SEARCH_GLOBAL_TYPES } from './constants';

export const fetchLmsDesignerAutoComplete = (key: string) =>
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Designer/AutoComplete')
    .get()
    .addQuery('key', key.trim())
    .addQuery('globalTypes', [...LMS_DESIGNER_SEARCH_GLOBAL_TYPES])
    .send();
